
      export default {
  "possibleTypes": {
    "Actor": [
      "Actor__Human",
      "Actor__System",
      "Actor__Unknown"
    ],
    "Actor__HasOne": [
      "Lifecycle__Event"
    ],
    "Asset__Comments__And__Media__HasMany": [
      "Driver__VehicleInspectionReport"
    ],
    "Asset__Comments__And__Media__Result": [
      "Asset__Comments__And__Media",
      "Error__EntityNotFound",
      "Error__DataIntegrity",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__UnclassifiedError"
    ],
    "Asset__Defect__HasMany": [
      "Driver__VehicleInspectionReport"
    ],
    "Asset__Defect__Resolution__Result": [
      "Asset__Defect__Resolution",
      "Error__EntityNotFound",
      "Error__DuplicateEntity",
      "Error__InputValidation",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Asset__Defect__Result": [
      "Asset__Defect",
      "Error__AccessForbidden",
      "Error__DataIntegrity",
      "Error__EntityNotFound",
      "Error__InputValidation",
      "Error__TimeoutError",
      "Error__UnclassifiedError"
    ],
    "Asset__Defect__Type__Errors": [
      "Error__EntityNotFound",
      "Error__InputValidation",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__AccessForbidden",
      "Error__UnexpectedRESTResponse"
    ],
    "Asset__Defect__Type__Result": [
      "Asset__Defect__Type",
      "Error__EntityNotFound",
      "Error__InputValidation",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__AccessForbidden",
      "Error__UnexpectedRESTResponse"
    ],
    "Asset__HasOne": [
      "Asset__Comments__And__Media",
      "Asset__Defect"
    ],
    "Asset__HasOneMaybe": [
      "WorkOrder"
    ],
    "Asset__HasVehicleAndOrTrailers": [
      "Driver__VehicleInspectionReport"
    ],
    "Asset__HasVehiclesMaybe": [
      "Driver__Shift"
    ],
    "Asset__Result": [
      "Asset",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Before_MayHaveOne": [
      "Lifecycle__Event"
    ],
    "Comment__Create__Result": [
      "Comment",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Comment__Delete__Result": [
      "Comment",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Comment__HasMany": [
      "Asset__Comments__And__Media",
      "Asset__Defect",
      "Asset__Defect__Resolution",
      "Driver__VehicleInspectionReport"
    ],
    "Comment__Read__Result": [
      "Comment",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Comment__Restore__Result": [
      "Comment",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Company__Result": [
      "Company",
      "Error__AccessForbidden",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse"
    ],
    "Company__Settings__Drive__Result": [
      "Company__Settings__Drive",
      "Error__DataIntegrity",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__UnclassifiedError"
    ],
    "Company__Settings__Result": [
      "Company__Settings",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Company__Settings__Track__Result": [
      "Company__Settings__Track",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "DateTime__HasOne": [],
    "Driver__HasOne": [
      "Driver__VehicleInspectionReport"
    ],
    "Driver__Result": [
      "Driver",
      "Error__AccessForbidden",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Driver__Shift__Connection__Result": [
      "Driver__Shift__Connection",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Driver__Shift__Result": [
      "Driver__Shift",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "Driver__VehicleInspectionReport__Connection__Result": [
      "Driver__VehicleInspectionReport__Connection",
      "Error__EntityNotFound",
      "Error__DataIntegrity",
      "Error__InputValidation",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__UnclassifiedError",
      "Error__UnexpectedRESTResponse",
      "Error__AccessForbidden"
    ],
    "Driver__VehicleInspectionReport__HasMany": [
      "Asset"
    ],
    "Driver__VehicleInspectionReport__Result": [
      "Driver__VehicleInspectionReport",
      "Error__EntityNotFound",
      "Error__DataIntegrity",
      "Error__InputValidation",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__UnclassifiedError",
      "Error__UnexpectedRESTResponse",
      "Error__AccessForbidden"
    ],
    "Driver__VehicleInspectionReport__Summary__Result": [
      "Driver__VehicleInspectionReport__Summary",
      "Error__EntityNotFound",
      "Error__InputValidation",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__UnclassifiedError"
    ],
    "Error": [
      "Error__AccessForbidden",
      "Error__DataIntegrity",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__DatabaseException",
      "Error__DuplicateEntity",
      "Error__EntityNotFound",
      "Error__InputValidation",
      "Error__SourceError",
      "Error__TimeoutError",
      "Error__UnclassifiedError",
      "Error__UnexpectedRESTResponse"
    ],
    "Error__Action__HasOneMaybe": [
      "Error__InputValidation"
    ],
    "Error__Code__HasOneMaybe": [
      "Error__DatabaseException"
    ],
    "Error__Entity__HasOne": [
      "Error__AccessForbidden",
      "Error__DataIntegrity",
      "Error__DuplicateEntity",
      "Error__EntityNotFound",
      "Error__InputValidation"
    ],
    "Error__Node__HasOne": [
      "Error__DuplicateEntity"
    ],
    "Error__Node__HasOneMaybe": [
      "Error__DataIntegrity",
      "Error__InputValidation"
    ],
    "Error__Source__HasOneMaybe": [
      "Error__DataIntegrity",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine",
      "Error__DatabaseException"
    ],
    "History__HasOne": [],
    "Human": [
      "Driver"
    ],
    "Human__HasOne": [
      "Actor__Human"
    ],
    "Lifecycle__Created": [
      "Lifecycle"
    ],
    "Lifecycle__Deleted": [
      "Lifecycle"
    ],
    "Lifecycle__HasOne": [
      "Asset__Comments__And__Media",
      "Asset__Defect",
      "Asset__Defect__Resolution",
      "Asset__Defect__Type",
      "Comment",
      "Driver__VehicleInspectionReport",
      "Media",
      "Signature"
    ],
    "Lifecycle__Modified": [
      "Lifecycle"
    ],
    "Lifecycle__Restored": [
      "Lifecycle"
    ],
    "Lifecycle__Result": [
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Lifecycle__Submitted": [
      "Lifecycle"
    ],
    "Location__Create__Result": [
      "Location",
      "Error__DataIntegrity",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Location__Delete__Result": [
      "Location",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Location__HasOneMaybe": [
      "Media__Type__Image"
    ],
    "Location__Read__Result": [
      "Location",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Location__Restore__Result": [
      "Location",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Media__Create__Result": [
      "Media",
      "Error__DataIntegrity",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Media__Delete__Result": [
      "Media",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Media__HasMany": [
      "Asset__Comments__And__Media",
      "Asset__Defect",
      "Comment",
      "Driver__VehicleInspectionReport"
    ],
    "Media__Read__Result": [
      "Media",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Media__Restore__Result": [
      "Media",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Media__Type": [
      "Media__Type__File",
      "Media__Type__Image"
    ],
    "Node": [
      "Asset",
      "Asset__Comments__And__Media",
      "Asset__Defect",
      "Asset__Defect__Resolution",
      "Asset__Defect__Type",
      "Asset__Type",
      "ClientApplication",
      "Comment",
      "Company",
      "Company__Settings__Drive",
      "Company__Settings__Track",
      "Driver",
      "Driver__Shift__Node",
      "Driver__VehicleInspectionReport",
      "Lifecycle__Event",
      "Media",
      "Signature",
      "WorkOrder"
    ],
    "Pagination__Connection": [
      "Asset__Defect__Connection",
      "Driver__Shift__Connection",
      "Driver__VehicleInspectionReport__Connection"
    ],
    "Pagination__Edge": [
      "Asset__Defect__Edge",
      "Driver__Shift__Edge",
      "Driver__VehicleInspectionReport__Edge"
    ],
    "Pagination__HasPagination": [],
    "Settings__Email__Address__List": [
      "Settings__Email__Report",
      "Settings__Recurring__Email__Report"
    ],
    "Signature__Create__Result": [
      "Signature",
      "Error__DataIntegrity",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Signature__Delete__Result": [
      "Signature",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Signature__HasOne": [
      "Asset__Defect__Resolution",
      "Driver__VehicleInspectionReport"
    ],
    "Signature__Read__Result": [
      "Signature",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Signature__Restore__Result": [
      "Signature",
      "Error__EntityNotFound",
      "Error__DatabaseException",
      "Error__DatabaseBadRequest",
      "Error__DatabaseEngine"
    ],
    "Version__Result": [
      "Versions",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ],
    "WorkOrder__HasMany": [
      "Asset__Defect"
    ],
    "WorkOrder__Result": [
      "WorkOrder",
      "Error__AccessForbidden",
      "Error__EntityNotFound",
      "Error__TimeoutError",
      "Error__UnexpectedRESTResponse",
      "Error__UnclassifiedError"
    ]
  }
}
    